import React from "react";

function Header() {
  return (
    <header className="header">
      <h1>Bordle</h1>
    </header>
  );
}

export default React.memo(Header);
